import React from "react";

const Return_Values = () => {
  return (
    <div>
      <h1>Return_Values Component</h1>
      <p>Content for Return_Values goes here...</p>
    </div>
  );
};

export default Return_Values;
